'use strict';

const FINDATION_STORAGE_KEY = 'findationMatches';
const FINDATION_LEGACY_KEYS = ['shadesEntered', 'shadesRecomm', 'selectedShadeID', 'shadesColor'];
const FINDATION_LOAD_TIMEOUT_MS = 10000;
let findationReadyPromise = null;
let findationCallbacksBound = false;

function isFindationApiReady() {
    return !!(window.Findation && typeof window.Findation.init === 'function');
}

function whenFindationReady() {
    if (findationReadyPromise) return findationReadyPromise;

    findationReadyPromise = new Promise(function (resolve, reject) {
        if (isFindationApiReady()) {
            resolve(window.Findation);
            return;
        }

        const script = document.getElementById('findation-script');
        if (!script) {
            reject(new Error('Findation script tag not found on this page'));
            return;
        }

        let settled = false;
        const timeoutId = setTimeout(function () {
            finish(new Error('Findation script timed out'));
        }, FINDATION_LOAD_TIMEOUT_MS);

        function finish(error) {
            if (settled) return;
            settled = true;
            clearTimeout(timeoutId);
            script.removeEventListener('load', onLoad);
            script.removeEventListener('error', onError);
            if (error) {
                reject(error);
            } else {
                resolve(window.Findation);
            }
        }
        function onLoad() {
            finish(isFindationApiReady() ? null : new Error('Findation loaded but API is missing'));
        }
        function onError() {
            finish(new Error('Findation script failed to load'));
        }

        script.addEventListener('load', onLoad);
        script.addEventListener('error', onError);
    });

    return findationReadyPromise;
}

function hideFindation() {
    $('.findation-widget-wrapper').hide();
    $('.findation-widget-wrapper-result').addClass('hide');
}

function observeFindationIframe() {
    const $widgetWrapper = $('.findation-widget-wrapper');
    const observer = new MutationObserver(function () {
        const $iframe = $widgetWrapper.find('#findation-button-iframe');
        const height = parseInt($iframe.css('height'), 10) || 0;
        if ($('#findation-iframe').length > 0 && height > 1) {
            $widgetWrapper.removeClass('hide');
            observer.disconnect();
            clearTimeout(observerTimeout);
        } else {
            $widgetWrapper.addClass('hide');
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    const observerTimeout = setTimeout(function () {
        observer.disconnect(); 
    }, FINDATION_LOAD_TIMEOUT_MS);

}

function initFindationButton(Findation) {
    const $widgetWrapper = $('.findation-widget-wrapper');
    const buttonEl = $widgetWrapper.find('.findation-widget-button')[0];
    if (!buttonEl || buttonEl.getAttribute('data-findation-init') === 'true') return;

    buttonEl.setAttribute('data-findation-init', 'true');
    Findation.init(buttonEl, SitePreferences.FINDATION_KEY, {
        productUrl: $widgetWrapper.attr('data-producturl'),
        domain: 'https://findation.com'
    });
    observeFindationIframe();
}

function bindFindationCallbacks(Findation) {
    if (findationCallbacksBound) return;
    findationCallbacksBound = true;

    Findation.resultsWillRender = function (html) {
        const productId = getFindationProductId();

        if (typeof html !== 'string' || !html.includes('match-card')) {
            clearFindationMatch(productId);
            return html;
        }

        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const wrapper = tmp.querySelector('[data-external-id]');
        const shadeDescWrapper = tmp.querySelector('.shade-desc');

        if (wrapper && shadeDescWrapper) {
            const $swatch = findSwatchByVariantId(wrapper.getAttribute('data-external-id'));
            if ($swatch.length) {
                const swatchStyle = $swatch.find('.swatch-block').attr('style');
                const shadeDesc = $swatch.find('img').attr('data-desc');
                if (swatchStyle) {
                    wrapper.setAttribute('style', swatchStyle);
                    shadeDescWrapper.textContent = shadeDesc || '';
                    saveFindationMatch(productId, { shadeColor: swatchStyle });
                }
            }
        }
        return tmp.innerHTML;
    };

    Findation.onSearchComplete = function (data) {
        const productId = getFindationProductId();
        if (!productId) return;

        const externalId = normalizeId(data && data.externalId);
        const $swatch = externalId ? findSwatchByVariantId(externalId) : $();

        // Save only if the recommended shade exists on current product's swatches
        if (data && data.matchSuccess && data.recommendedShade && $swatch.length) {
            saveFindationMatch(productId, {
                shadesEntered: data.shadesEntered,
                recommendedShade: data.recommendedShade,
                externalId: externalId
            });
        } else {
            // Shade from another product (or no match): don't keep a stale entry
            clearFindationMatch(productId);
        }
    };

    Findation.widgetDidClose = function () {
        const productId = getFindationProductId();
        const match = getFindationMatch(productId);
        const $swatch = match ? findSwatchByVariantId(match.externalId) : $();

        if ($swatch.length && !$swatch.parent('li').hasClass('selected')) {
            $swatch.trigger('click');
        } else {
            renderSavedFindationMatch(productId);
        }
    };
}

function normalizeId(value) {
    return value === null || value === undefined ? '' : String(value).trim();
}

function findSwatchByVariantId(variantId) {
    const targetId = normalizeId(variantId);
    if (!targetId) return $();
    return $('.color-filter-wrapper .swatchanchor').filter(function () {
        return normalizeId($(this).attr('data-variantid')) === targetId;
    }).first();
}

function getFindationProductId() {
    return normalizeId($('.findation-widget-wrapper').attr('data-masterid'));
}

function readFindationMatches() {
    try {
        const parsed = JSON.parse(sessionStorage.getItem(FINDATION_STORAGE_KEY));
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (e) {
        return {};
    }
}

function writeFindationMatches(matches) {
    try {
        sessionStorage.setItem(FINDATION_STORAGE_KEY, JSON.stringify(matches));
    } catch (e) { /* storage full or blocked – fail silently */ }
}

function getFindationMatch(productId) {
    return productId ? readFindationMatches()[productId] || null : null;
}

function saveFindationMatch(productId, fields) {
    if (!productId) return;
    const matches = readFindationMatches();
    matches[productId] = Object.assign({}, matches[productId], fields, { productId: productId });
    writeFindationMatches(matches);
}

function clearFindationMatch(productId) {
    if (!productId) return;
    const matches = readFindationMatches();
    delete matches[productId];
    writeFindationMatches(matches);
}


function clearLegacyFindationKeys() {
    try {
        FINDATION_LEGACY_KEYS.forEach(function (key) { sessionStorage.removeItem(key); });
    } catch (e) {}
}

function renderSavedFindationMatch(productId) {
    const $widget = $('.findation-widget-wrapper');
    const $result = $('.findation-widget-wrapper-result');
    const match = getFindationMatch(productId);
    const $swatch = match ? findSwatchByVariantId(match.externalId) : $();

    // No match for this product, or the saved shade isn't on this PDP: show the default widget
    if (!match || !$swatch.length) {
        $widget.show();
        $result.addClass('hide');
        return;
    }

    const entered = Array.isArray(match.shadesEntered) ? match.shadesEntered[0] : null;
    const shadeColor = match.shadeColor || $swatch.find('.swatch-block').attr('style') || '';

    $widget.hide();
    $result.removeClass('hide');
    $result.find('.findation-widget-wrapper-result-shade').attr('style', shadeColor);
    $result.find('.findation-widget-wrapper-result-pName').text('Your match : ' + normalizeId(match.recommendedShade));
    $result.find('.findation-widget-wrapper-result-desc').text(entered && entered.fullName ? 'Based on ' + entered.fullName : '');
   
    $result.off('click.findation').on('click.findation', '.findation-widget-wrapper-result-button', function (e) {
        e.preventDefault();
        if (window.Findation && typeof window.Findation.openWidget === 'function') {
            window.Findation.openWidget();
        }
    });
}

export function initFindation() {
    if (!$('.findation-widget-wrapper').length) return;
    clearLegacyFindationKeys();
    renderSavedFindationMatch(getFindationProductId());

    whenFindationReady()
        .then(function (Findation) {
            if (typeof SitePreferences === 'undefined' || !SitePreferences.FINDATION_KEY) {
                throw new Error('SitePreferences.FINDATION_KEY is not set');
            }
            bindFindationCallbacks(Findation);
            initFindationButton(Findation); // finds the current button, even after an AJAX swap
        })
        .catch(function (error) {
            hideFindation(); // don't leave an empty button or a card whose "Change" does nothing
            if (window.console) console.warn('[Findation]', error.message);
        });
}